import {
  CAlert,
  CButton,
  CCol,
  CFormCheck,
  CFormLabel,
  CFormTextarea,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CSpinner,
} from '@coreui/react';
import React, { useState } from 'react';
import type { CatSubscription, UpdateCatInfoPayload } from '../../types';

interface CatInfoEditModalProps {
  catSubscription: CatSubscription | null;
  visible: boolean;
  loading: boolean;
  error: string | null;
  onSave: (data: UpdateCatInfoPayload) => void;
  onClose: () => void;
}

export const CatInfoEditModal: React.FC<CatInfoEditModalProps> = ({
  catSubscription,
  visible,
  loading,
  error,
  onSave,
  onClose,
}) => {
  const [passedAway, setPassedAway] = useState<boolean | null>(null);
  const [hasAllergies, setHasAllergies] = useState<boolean | null>(null);
  const [notes, setNotes] = useState('');
  const resetKey = `${visible}:${catSubscription?.id ?? ''}:${catSubscription?.updatedAt ?? ''}`;
  const [previousResetKey, setPreviousResetKey] = useState(resetKey);

  if (resetKey !== previousResetKey) {
    setPreviousResetKey(resetKey);
    setPassedAway(catSubscription?.passedAway ?? null);
    setHasAllergies(catSubscription?.hasAllergies ?? null);
    setNotes(catSubscription?.notes || '');
  }

  if (!catSubscription) {
    return null;
  }

  const handleSave = () => {
    onSave({
      passedAway,
      hasAllergies,
      notes: notes === '' ? null : notes,
    });
  };

  return (
    <CModal visible={visible} onClose={onClose}>
      <CModalHeader>
        <CModalTitle>Edit cat&apos;s information</CModalTitle>
      </CModalHeader>
      <CModalBody>
        {error && <CAlert color="danger">{error}</CAlert>}
        <CRow className="mb-3">
          <CCol>
            <CFormCheck
              id="passed-away"
              label="Passed Away"
              checked={passedAway === true}
              onChange={(event) => setPassedAway(event.target.checked)}
              disabled={loading}
            />
          </CCol>
          <CCol>
            <CFormCheck
              id="has-allergies"
              label="Has Allergies"
              checked={hasAllergies === true}
              onChange={(event) => setHasAllergies(event.target.checked)}
              disabled={loading}
            />
          </CCol>
        </CRow>
        <CFormLabel htmlFor="cat-notes">Notes</CFormLabel>
        <CFormTextarea
          id="cat-notes"
          value={notes}
          onChange={(event) => setNotes(event.target.value)}
          maxLength={500}
          rows={5}
          disabled={loading}
        />
        <div className="text-end text-muted mt-1">{notes.length}/500</div>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose} disabled={loading}>
          Cancel
        </CButton>
        <CButton color="primary" onClick={handleSave} disabled={loading}>
          {loading && <CSpinner size="sm" className="me-2" />}
          Save
        </CButton>
      </CModalFooter>
    </CModal>
  );
};
